import React from "react";
import { Col, Row } from "react-bootstrap";
import Langs from "../../app/lang/langs";
import exportIcon from "../../assets/images/export.png";
import exportIconFocus from "../../assets/images/exportFocus.png";
import ImageButton from "../../components/buttons/ImageButton";

/**
 * ContractsTopMenu
 *
 * Title and export button for ContractsView. Switching sub-view is done from the sidebar
 * submenu under "Contracts & Missions", not from here.
 */
export default function ContractsTopMenu({
  isMobile,
  selectedView,
  viewsOptions,
  onExportContracts,
  onExportMissions,
  onExportSuivisMissions,
}) {
  const currentLabel = viewsOptions.find((o) => o.value == selectedView)?.label;

  const renderExportButton = () => {
    if (selectedView == 0) {
      return (
        <div>
          <ImageButton
            image={exportIcon}
            imageFocus={exportIconFocus}
            onClick={onExportContracts}
            active={true}
            tooltip={<Langs str="Export contrats" />}
            width={32}
          />
        </div>
      );
    }
    if (selectedView == 1) {
      return (
        <div>
          <ImageButton
            image={exportIcon}
            imageFocus={exportIconFocus}
            onClick={onExportMissions}
            active={true}
            tooltip={<Langs str="Export missions" />}
            width={32}
          />
        </div>
      );
    }
    if (selectedView == 2) {
      return (
        <div>
          <ImageButton
            image={exportIcon}
            imageFocus={exportIconFocus}
            onClick={onExportSuivisMissions}
            active={true}
            tooltip={<Langs str="Export suivis missions" />}
            width={32}
          />
        </div>
      );
    }
    return null;
  };

  if (isMobile == 1) {
    return (
      <Row>
        <Col md={3}>
          <span className="headerTitle">{currentLabel}</span>
        </Col>
        {/* The sub-views moved to the sidebar submenu under "Contracts & Missions", so
            this column is now only the spacer between the title and the export button. */}
        <Col md={6} />
        <Col
          md={3}
          className="d-flex justify-content-end pe-4 align-items-center p-0 m-0 ms-auto"
        >
          {renderExportButton()}
        </Col>
      </Row>
    );
  }

  if (isMobile == 2 || isMobile == 3) {
    return (
      <Row>
        <Col md={5}>
          <span className="headerTitle">{currentLabel}</span>
        </Col>
        <Col
          md={7}
          className="d-flex justify-content-end align-items-center p-0 m-0 mt-3"
        >
          {renderExportButton()}
        </Col>
      </Row>
    );
  }

  return null;
}
